import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTE_KEYS } from 'legacyfrontend/constants';
import { useCustomSection } from '../../hooks/useCustomSection';
import { CustomSectionComp } from '../../components/custom-section/custom-section';
import MainCarousel from '../../components/home/MainCarousel';
import { selectBannersState } from '../../redux/selectors/application-selectors';
import { buildIdSlugPath, slugify } from '../../utils/slugify';

const CustomSection = () => {
  const { id, slug } = useParams();
  const history = useHistory();
  const sectionData = useCustomSection(id);
  const { sectionTitle } = sectionData;

  const { categoriesMainCarousel, ready, error } = useSelector(selectBannersState);
  const hasBanners = ready && !error && categoriesMainCarousel && categoriesMainCarousel.length > 0;
  const isLoadingBanners = !ready;

  useEffect(() => {
    const hasCurrentSectionData = String(sectionData.loadedSectionId) === String(id);
    const slugFromTitle = slugify(sectionTitle);

    if (!hasCurrentSectionData) return;
    if (!slugFromTitle) return;

    const canonicalPath = buildIdSlugPath(ROUTE_KEYS.CUSTOM_SECTION, id, sectionTitle);

    if (!slug || slug !== slugFromTitle) {
      history.replace(canonicalPath);
    }
  }, [id, slug, sectionTitle, sectionData.loadedSectionId, history]);

  return (
    <div>
      <MainCarousel
        defaultB={true}
        defaultOnly={true}
        id={id}
      />
      {!hasBanners && !isLoadingBanners && <CustomSectionComp id={id} sectionData={sectionData} />}
    </div>
  );
};

export default CustomSection;
